(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapeha-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const close = event.target.closest('.mapeha-announcement__close');
  if (close) {
    close.closest('.mapeha-announcement').hidden = true;
    document.querySelector('.mapeha-header__mobile-menu summary')?.focus({ preventScroll: true });
    return;
  }
  const link = event.target.closest('.mapeha-announcement__signup');
  if (!link) return;
  const signup = document.getElementById('mapeha-newsletter');
  if (!signup) return;
  event.preventDefault();
  const header = link.closest('.shopify-section');
  signup.style.scrollMarginTop = ((header?.getBoundingClientRect().height || 100) + 24) + 'px';
  signup.focus({ preventScroll: true });
  signup.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapeha-product"]) return;
  try {
    
if (!customElements.get('mapeha-gallery-navigation')) {
  customElements.define('mapeha-gallery-navigation', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mapeha-product__gallery');
      this.slides = Array.from(this.track.children);
      this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-index]'));
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      this.update = () => {
        const trackLeft = this.track.getBoundingClientRect().left;
        this.index = this.slides.reduce((nearest, slide, index) =>
          Math.abs(slide.getBoundingClientRect().left - trackLeft) <
          Math.abs(this.slides[nearest].getBoundingClientRect().left - trackLeft) ? index : nearest, 0);
        this.thumbnails.forEach((button, index) => button.setAttribute('aria-current', String(index === this.index)));
        const active = this.thumbnails[this.index];
        const strip = active?.parentElement;
        if (active && strip) {
          const item = active.getBoundingClientRect();
          const bounds = strip.getBoundingClientRect();
          if (matchMedia('(min-width:990px)').matches) {
            if (item.top < bounds.top || item.bottom > bounds.bottom) strip.scrollBy({ top:item.top - bounds.top - (bounds.height - item.height) / 2, behavior:'instant' });
          } else if (item.left < bounds.left || item.right > bounds.right) {
            strip.scrollBy({ left:item.left - bounds.left - (bounds.width - item.width) / 2, behavior:'instant' });
          }
        }
      };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-gallery-index]');
        if (!button) return;
        this.update();
        const targetIndex = Number(button.dataset.galleryIndex);
        const target = this.slides[Math.max(0, Math.min(this.slides.length - 1, targetIndex))];
        this.track.scrollBy({
          left: target.getBoundingClientRect().left - this.track.getBoundingClientRect().left,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }, { signal });
      this.track.addEventListener('scroll', this.update, { passive:true, signal });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
